var emailMap = {
  id: 'id',
  log: 'log',
  dateCreated: 'dateCreated',
  dateModified: 'dateModified'
};
export default emailMap;